'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var getFullItemDetails = require('./getFullItemDetails.js');

const evaluateItemEligibility = _ref => {
  var _itemDetails$eligibil;
  let {
    state,
    allowMultiPackageClaims,
    item,
    packageId
  } = _ref;
  const itemDetails = getFullItemDetails["default"]({
    claimEligibilityInfo: state.claimEligibilityInfo,
    itemUid: item.itemRefId,
    packageId
  });
  if (!(itemDetails !== null && itemDetails !== void 0 && itemDetails.eligibility)) throw new Error('Insufficient item details');

  // If the item is ineligible for a reason coming from the API, prefer that reason
  const originalEligibility = {
    isEligible: itemDetails.eligibility.isEligible,
    ineligibilityReason: ((_itemDetails$eligibil = itemDetails.eligibility.ineligibilityReason) === null || _itemDetails$eligibil === void 0 ? void 0 : _itemDetails$eligibil.reason) ?? null
  };
  if (!itemDetails.eligibility.isEligible) {
    return originalEligibility;
  }
  const claimDetails = state.itemClaims[`${item.itemRefId}_${packageId}`];
  const {
    eligibleQuantity
  } = itemDetails.eligibility;

  // Evaluate whether the maximum number of items have been selected
  const isSelected = Boolean(claimDetails);
  const isEligibleQuantityMaxed = eligibleQuantity > 0 && itemDetails.remainingEligibleQuantity === 0;
  if (!isSelected && isEligibleQuantityMaxed) {
    return {
      isEligible: false,
      ineligibilityReason: 'MaxClaimableQuantityReached'
    };
  }

  // Evaluate whether items from another shipment have been added
  if (!allowMultiPackageClaims) {
    const claimOnAnotherPackageExists = Object.keys(state.itemClaims).some(itemClaimId => {
      const itemClaim = state.itemClaims[itemClaimId];
      return itemClaim.packageId !== packageId;
    });
    if (claimOnAnotherPackageExists) {
      return {
        isEligible: false,
        ineligibilityReason: 'SinglePackageClaimRestriction'
      };
    }
  }
  return originalEligibility;
};
const updateEvaluatedItemEligibility = _ref2 => {
  let {
    state,
    allowMultiPackageClaims
  } = _ref2;
  if (!state.claimEligibilityInfo) throw new Error('Insufficient data to update item');
  return {
    ...state,
    claimEligibilityInfo: {
      ...state.claimEligibilityInfo,
      shipments: state.claimEligibilityInfo.shipments.map(shipment => ({
        ...shipment,
        items: shipment.items.map(item => ({
          ...item,
          evaluatedEligibility: evaluateItemEligibility({
            state,
            allowMultiPackageClaims,
            item,
            packageId: shipment.id
          })
        }))
      }))
    }
  };
};

exports["default"] = updateEvaluatedItemEligibility;
